const CTRL_TIPO_TAREFA = {
    ESTEIRA: 1,
    INTERRUPCAO: 2
};

const CTRL_TIPO_PARALELISMO = {
    INDEPENDENTE: 1,
    CONDICIONAL: 2
};

const CTRL_STATUS = {
    AGUARDANDO_PARALELISMO: 7,
    INTERROMPIDA: 3,
    DISPONIVEL: 4,
    CANCELAMENTO: 5
};

const CTRL_TRATATIVAS = {
    RESOLVER_INTERRUPCAO: 7,
    ATUALIZAR: 8
};

const CTRL_ACOES = {
    ENVIAR_TAREFA: 1,
    MENSAGEM: 2,
    INTEGRACAO_RPA: 3
};

const CTRL_GATILHOS = {
    MOBILIDADE: 1,
    TEMPORIZADOR: 2
};

const CTRL_TIPO_TEMPORIZADOR = {
    NAO_SE_REPETE: 1,
    HORAS: 2,
    DIARIAMENTE: 3,
    SEMANALMENTE: 4,
    MENSALMENTE: 5
};

const STATUS_CLA = {
    PENDENTE_DE_CONSTRUCAO_DE_ACESSO_FISICO: "PENDENTE DE CONSTRUCAO DE ACESSO FISICO", 
    PENDENTE_DE_ATIVACAO_DO_SERVICO_PELO_APROVISIONADOR: "PENDENTE DE ATIVAÇÃO DO SERVIÇO PELO APROVISIONADOR",
    PENDENTE_DE_DESATIVACAO_DO_ACESSO_FISICO: "PENDENTE DE DESATIVACAO DO ACESSO FISICO",
    ACESSO_INSTALADO_PENDENTE_DE_ENTREGA_AO_SERVICO: "ACESSO INSTALADO/PENDENTE DE ENTREGA AO SERVICO",
    PENDENTE_DE_ATIVACAO_DO_SERVICO: "PENDENTE DE ATIVACAO DO SERVICO",
    CANCELADO: "CANCELADO",
    CONCLUIDA: "CONCLUIDA",
    DESATIVADO: "DESATIVADO"
};

const CTRL_TIPO_GATILHO_TEMPORIZADOR = {
    TAREFAS: 1,
    PROCESSOS: 2,
    MACROPROCESSOS: 3
};

const CTRL_TIPOS_PROJETOS = {
    ESP: 1,
    PRO: 2,
    QUA: 3
};

const CTRL_METODOS = {
    EXECUTA_SGA_PLUS: 65,
    ORQUESTRADOR: 63
};

const CTRL_CLASSIFICACAO_GROSS = {
    GROSS: 1,
    SERVICO: 2,
    OUTROS: 3,
    INTERCOMPANY: 4
};

const CTRL_REGIONAIS = {
    SAO_PAULO_METRO: 10,
    SAO_PAULO_LESTE: 11,
    SAO_PAULO_OESTE: 13
};

const CTRL_SISTEMAS = {
    SAIP: 3,
    CLA: 4,
    SGAP: 6,
    SAPWEB: 7,
};

const CTRL_MODULOS = {
    RECUPERACAO: 1,
    INSTALACAO: 2,
};

export {
    CTRL_TIPO_TAREFA,
    CTRL_TIPO_PARALELISMO,
    CTRL_STATUS,
    CTRL_TRATATIVAS,
    CTRL_ACOES,
    CTRL_GATILHOS,
    CTRL_TIPO_TEMPORIZADOR,
    STATUS_CLA,
    CTRL_TIPO_GATILHO_TEMPORIZADOR,
    CTRL_TIPOS_PROJETOS,
    CTRL_CLASSIFICACAO_GROSS,
    CTRL_REGIONAIS,
    CTRL_METODOS,
    CTRL_SISTEMAS,
    CTRL_MODULOS,
}